module.exports = ori_vendor_2;